import ResponseMapModel from "./ResponseMapModel";
import WidgetBaseDetailModel from "./WidgetBaseDetailModel";
import WidgetLanguageDetailModel from "./WidgetLanguageDetailModel";
import { WidgetTypeEnum } from "../../common/enum";
import AudioFileModel from "./AudioFileModel";

export default class AskQuestionWidgetModel extends WidgetBaseDetailModel {
	public timeout: number;
	public questionText: WidgetLanguageDetailModel[];
	public questionAudioFile: AudioFileModel[];
	public responseMap: ResponseMapModel[];
	public maxRetries: number;
	public retryMessage: WidgetLanguageDetailModel[];
	public retryAudioFile: AudioFileModel[];
	public failureActionType: string;
	public failureDefaultValue?: string;
	public failureMessage: WidgetLanguageDetailModel[];
	public failureAudioFile: AudioFileModel[];
	public nextAction: string;
	public isVoiceNoteAllowed: boolean;

	public constructor() {
		super();
		this.type = WidgetTypeEnum.AskQuestion;
		this.timeout = 0;
		this.questionText = [];
		this.questionAudioFile = [];
		this.responseMap = [];
		this.maxRetries = 0;
		this.retryMessage = [];
		this.retryAudioFile = [];
		this.failureActionType = "";
		this.failureMessage = [];
		this.failureAudioFile = [];
		this.nextAction = "";
		this.isVoiceNoteAllowed = false;
	}
}
